export default __webpack_public_path__ + "static/max-cantor-0bd7a6bf6119185c3ceea85cf45d4d93.png";